<nz-timeline class='timeline'>
  <ng-container *ngFor='let key of date'>
    <nz-timeline-item [nzDot]='dotTpl'>
      <div *ngFor='let item of listOfData[key]' class='flexFull' (click)='showDetails(item)'>
        <move-record-item [data]="item['record_json_content']" [keys]='keys'
                          [isCreate]="item['record_action_id']==1" [title]="item['record_title']"></move-record-item>
      </div>
    </nz-timeline-item>
    <ng-template #dotTpl>
      <div class='flexRow timeline-date'>
        <div class='time'>{{ key }}</div>
        <div class='point'></div>
      </div>
    </ng-template>
  </ng-container>
</nz-timeline>
